import React from 'react';
import MuiExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MuiChip from '@material-ui/core/Chip';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import TextField from '@material-ui/core/TextField';
import { useRouter } from 'next/router';
import { withStyles } from '@material-ui/core';
import MuiExpansionPanel from '@material-ui/core/ExpansionPanel';
import Typography from '@material-ui/core/Typography';
import styled from 'styled-components';
import qs from 'query-string';

const ExpansionPanel = withStyles({
  root: {
    border: '1px solid rgba(0, 0, 0, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
})(MuiExpansionPanel);

const ExpansionPanelSummary = withStyles({
  content: {
    alignItems: 'center',
  },
})(MuiExpansionPanelSummary);

const PanelHeading = withStyles({
  h6: {
    width: '100%',
    fontWeight: 'normal',
    fontSize: '13px',
  },
})(Typography);
const Chip = styled(MuiChip)`
  font-size: 10px !important;
  background: ${({ theme }) => theme.colors.primary} !important;
`;

type KeywordPanel = {
  isWantedSearch: boolean;
};
const KeywordPanel = ({ isWantedSearch }: KeywordPanel) => {
  const router = useRouter();
  const { query } = router;
  const [searchText, setSearchText] = React.useState('');
  const [activeText, setActiveText] = React.useState(query.to_search || '');

  const onChangeText = (value: string) => {
    setSearchText(value);
    setActiveText(value);
    query.to_search = value;
    if (value) {
      if (isWantedSearch) {
        router.push(`/wanted-search?${qs.stringify(query)}`);
      } else {
        router.push(`/search?${qs.stringify(query)}`);
      }
    } else {
      delete query.to_search;
      if (isWantedSearch) {
        router.push(`/wanted-search?${qs.stringify(query)}`);
      } else {
        router.push(`/search?${qs.stringify(query)}`);
      }
    }
  };
  const [expanded, setExpanded] = React.useState(true);

  const handlePanelChange = (event: any, isExpanded: boolean) => {
    setExpanded(!!isExpanded);
  };

  return (
    <ExpansionPanel defaultExpanded expanded={expanded} onChange={handlePanelChange}>
      <ExpansionPanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <PanelHeading variant="h6">By Title/Keyword</PanelHeading>
        {activeText.length > 0 && (
          <Chip
            size="small"
            label={query.to_search}
            onDelete={() => onChangeText('')}
            color="primary"
          />
        )}
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        <TextField
          onKeyUp={(e) => {
            if (e.keyCode === 13) {
              onChangeText(searchText);
            }
          }}
          value={searchText}
          placeholder="Search title/keyword"
          variant="outlined"
          size="small"
          onChange={(e) => setSearchText(e.target.value)}
        />
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );
};

export default KeywordPanel;
